import { render, staticRenderFns } from "./ConstUnitNumberFormInput.vue?vue&type=template&id=96cb6aa6&scoped=true&"
import script from "./ConstUnitNumberFormInput.vue?vue&type=script&lang=ts&"
export * from "./ConstUnitNumberFormInput.vue?vue&type=script&lang=ts&"
import style0 from "./ConstUnitNumberFormInput.vue?vue&type=style&index=0&id=96cb6aa6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cb6aa6",
  null
  
)

export default component.exports